import React from 'react';

export function StepInfoLabel() {
  return <>Základní informace</>;
}
